import { IndexedDBService, PulseEnvironment } from '@pulse/browser-shared';
import { PulseModule, SettingsConfigurations, isIndexedDBSupported } from '@pulse/common';
import { pulseSettingsdefaultConfigs } from './configuration';
import { settingsProviders } from './providers';
import { CookieSyncService } from './services/cookie-sync.service';

function buildConfig(
    userConfig: Partial<SettingsConfigurations>,
): Required<SettingsConfigurations> {
    const config: Required<SettingsConfigurations> = {
        ...pulseSettingsdefaultConfigs,
        ...userConfig,
    };

    return config;
}

export const SettingsModule = new PulseModule<SettingsConfigurations>()
    .provide(settingsProviders)
    .beforeInit(buildConfig)
    .onInit(
        async (
            _config: SettingsConfigurations,
            indexedDBService: IndexedDBService,
            env: PulseEnvironment,
            cookieSyncService: CookieSyncService,
        ) => {
            if (await isIndexedDBSupported(env.win, true)) {
                await indexedDBService.connectDB();
            }
            cookieSyncService.startService();
        },
        [IndexedDBService, PulseEnvironment, CookieSyncService],
    );
